import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { BooleanProperty } from '../common/boolean-property';
import { NumberProperty } from '../common/number.property';
import { MdlTabPanelComponent } from './mdl-tab-panel.component';


export class MdlTabsComponent implements AfterContentInit, OnChanges {

   @NumberProperty() public selectedIndex: number = 0;
   @BooleanProperty() protected isRipple = false;
   public selectedTabEmitter = new EventEmitter();

   protected tabs: QueryList<MdlTabPanelComponent>;

  public ngAfterContentInit() {
    this.updateSelectedTabIndex();
  }

  public ngOnChanges(changes: SimpleChanges): any {
    if ( changes['selectedIndex'] ) {
      this.updateSelectedTabIndex();
    }
  }

  private updateSelectedTabIndex() {
    if ( this.tabs ) {
      this.tabs.forEach( tab => tab.isActive = false );
      if (this.tabs.toArray().length > 0 && this.selectedIndex < this.tabs.toArray().length) {
        this.tabs.toArray()[this.selectedIndex].isActive = true;
      }
    }
  }

  public tabSelected(tab: MdlTabPanelComponent) {
    if (tab.disabled) {
      return;
    }

    let index = this.tabs.toArray().indexOf(tab);
    if (index != this.selectedIndex) {
      this.selectedIndex = index;
      this.updateSelectedTabIndex();
      this.selectedTabEmitter.emit({index: this.selectedIndex});
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-tabs',
  host: {
    '[class.mdl-tabs]': 'true',
    '[class.is-upgraded]': 'true'
  },
  template:
  `
   <div class="mdl-tabs__tab-bar">
      <div *ngFor="let tab of tabs.toArray()">
        <div
          *ngIf="tab.titleComponent"
          class="mdl-tabs__tab"
          (click)="tabSelected(tab)"
          [mdl-ripple]="isRipple && !tab.disabled"
          [ngClass]="{'is-active': tab.isActive, 'disabled': tab.disabled}"
          [append-view-container-ref]="tab.titleComponent.vcRef"></div>
        <a *ngIf="!tab.titleComponent" href="javascript:void(0)"
              (click)="tabSelected(tab)"
              class="mdl-tabs__tab"
              [mdl-ripple]="isRipple && !tab.disabled"
              [ngClass]="{'is-active': tab.isActive, 'disabled': tab.disabled}">{{tab.title}}</a>
       </div>
  </div>
  <ng-content></ng-content>
  `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'selectedIndex': [{ type: Input, args: ['mdl-tab-active-index', ] },],
'isRipple': [{ type: Input, args: ['mdl-ripple', ] },],
'selectedTabEmitter': [{ type: Output, args: ['mdl-tab-active-changed', ] },],
'tabs': [{ type: ContentChildren, args: [MdlTabPanelComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
